export enum AdmissionEnum {
  IOWA = 'IOWA',
  IORM = 'IORM',
  SOWA = 'SOWA',
  IRMT = 'IRMT',
  IPTM = 'IPTM',
  IMTF = 'IMTF',
  SIRM = 'SIRM',
  SOOA = 'SOOA',
  SIWO = 'SIWO',
  SIOP = 'SIOP',
}
